import React from "react";

export default function SampleAvailableFacet({
  handleFilterSample,
  productSamples,
  selectedSample,
}) {
  const sampleVal = selectedSample == "Yes" ? "" : "Yes";
  const sampleClass =
    selectedSample == "Yes" ? "sampleActive" : "sampleInactive";
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("samples_available_facets") &&
    plpFacetLabel.sample_available_facet != ""
      ? plpFacetLabel.sample_available_facet
      : "Sample Available";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        <div
          className={`smapleIcon ${sampleClass}`}
          id={`sample-available-filter`}
          data-value={sampleVal}
          onClick={(e) =>
            handleFilterSample(
              "samples_available_facets",
              e.target.dataset.value
            )
          }>
          <span className="samplePoint"></span>
        </div>
        {`Yes (${productSamples["Yes"] ? productSamples["Yes"] : 0})`}
      </div>
    </div>
  );
}
